// @flow
import StringAttributeModel from "./StringAttributeModel";
import { ATTRIBUTE_WIDTH } from "../../constants";

/**
 * Memo attribute
 */
export default class MemoAttributeModel extends StringAttributeModel {
  /**
   */
  static isApplicableModel(contributions: Object): boolean {
    const rows = contributions?.rows;
    return contributions.type === "memo" || (rows && rows > 1);
  }

  /**
   */
  get type(): string {
    return "memo";
  }

  /**
   * Retrieve number of rows to render in a textarea and wysiwyg input
   */
  get rows(): number {
    const DEFAULT_ROWS_TO_RENDER = 10;

    return this.getContribution("rows", DEFAULT_ROWS_TO_RENDER);
  }

  /**
   * Get formatted switch
   */
  get formatted(): boolean {
    return this.getContribution("formatted", false);
  }

  /**
   */
  get readonlyWidth(): $Keys<typeof ATTRIBUTE_WIDTH> {
    return ATTRIBUTE_WIDTH.LARGE;
  }
}
